/*
 * @Descripttion: 
 * @Author: lijingjing56
 * @Date: 2024-08-09 13:59:22
 * @LastEditors: lijingjing56
 * @LastEditTime: 2025-01-10 10:07:04
 */
require('@/static/scss/index.scss') 

import Vue from 'vue'
import App from './App.vue'
import { createRouter } from './router'
import { createStore } from './store'
import { sync } from 'vuex-router-sync'

const JadPc = require('@jadfe/jad-pc')
import '@jadfe/jad-pc/dist/jad.css';
require('@/static/scss/jadpc.scss')

// 解决 [vue-router] failed to resolve async component default: referenceerror: window is not defined 问题
if (typeof window === 'undefined') {
    global.window = {}
}

Vue.use(JadPc);

const routes = ['/cloud/home','/home','/cloud/solution','/cloud/login',
  '/cloud/about/us','/cloud/accountManage','/cloud/applyBind','/cloud/settle','/cloud/product',
  '/cloud/applySettle','/cloud/market','/cloud/dsp','/cloud/dmp','/cloud/rta','/cloud/cdp']

export function createApp(context) {
    const router = createRouter()
    const store = createStore()
    router.beforeEach((to, from, next) => {
      if (routes.indexOf(to.path)==-1) {
        next({path:'/home'})
      } else {
        next()
      }
    })
    // 同步路由状态(route state)到 store
    sync(store, router)

    const app = new Vue({
        router,
        store,
        render: h => h(App)
    })
    
    return { app, router, store }
}
